<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import menu from "@/menu.js";
import NavBar from "@/components/NavBar.vue";
import AsideMenu from "@/components/AsideMenu.vue";
import Overlay from "@/components/Overlay.vue";
const store = useStore();
const isAsideLgActive = computed(() => store.state.isAsideLgActive);
const overlayClick = () => {
  store.dispatch("asideLgToggle", false);
};
</script>

<template>    
  <nav-bar :class="[isAsideLgActive ? '-ml-40':'ml-0']" />
  <aside-menu :menu="menu" />
  <router-view  :class="[isAsideLgActive ? '-ml-40':'ml-0']" />
  <!-- <footer-bar /> -->
  <overlay
    v-show="isAsideLgActive"
    z-index="z-100"
    @overlay-click="overlayClick"
  />
</template>
